<template>
  <div class="full-wrapper flowmap-wrapper">
    <el-scrollbar :ref="scrollbarRef">
      <component class="h100 w100" :is="currentView" :active="active" :selected-node="selectedNode"></component>
    </el-scrollbar>
    <w-scroll-top-button style="z-index:200;" :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ScrollbarMixin from '@/mixins/scrollbar';
import WOracleFlowMap from './OracleFlowMap';
import WMySqlFlowMap from './MySqlFlowMap';
import WMsSqlFlowMap from './MsSqlFlowMap';
import WTiberoFlowMap from './TiberoFlowMap';
import WCubridFlowMap from './CubridFlowMap';

export default {
  name: 'WDatabaseFlowMap',
  mixins: [ScrollbarMixin],
  components: {
    WOracleFlowMap,
    WMySqlFlowMap,
    WMsSqlFlowMap,
    WTiberoFlowMap,
    WCubridFlowMap,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          // TODO: 트리 타입마다 treeKey가 같아도 다른 노드일 수 있음. 해당 부분 처리 추가 필요함.
          this.changeView();
        }
      },
    },
    // $route(to, from) {
    //   const toMenu = to.path.split('/')[1];
    //   const fromMenu = from.path.split('/')[1];
    //
    //   if (toMenu !== fromMenu || to.params.treeKey !== from.params.treeKey) {
    //     this.changeView();
    //   }
    // },
  },
  mounted() {
    this.setScrollData();
  },
  methods: {
    changeView() {
      const objtypeId = this.selectedNode.obj.objtypeId;

      // TODO: DB의 objtypeId 상수 객체 관리.
      if (objtypeId === 'ORACLE') {
        this.currentView = WOracleFlowMap.name;
      } else if (objtypeId === 'MYSQL') {
        this.currentView = WMySqlFlowMap.name;
      } else if (objtypeId === 'MSSQL') {
        this.currentView = WMsSqlFlowMap.name;
      } else if (objtypeId === 'TIBERO') {
        this.currentView = WTiberoFlowMap.name;
      } else if (objtypeId === 'CUBRID') {
        this.currentView = WCubridFlowMap.name;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/database-flow-map/index.vue